import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import Imgix from 'react-imgix'
import { RichText } from 'prismic-reactjs'
import LazyImage, { setPlaceholderImage } from '../LazyImage'

export default function ImageWithText({ slice }) {
  const doc = slice.primary
  const { width, height } = doc.image.dimensions
  return (
    <Root>
      <LazyImage
        placeholder={setPlaceholderImage(width, height)}
        src={doc.image.url}
        alt={doc.image.alt}
        width={width}
      />
      <div>
        <RichText render={doc.text} />
      </div>
    </Root>
  )
}

const Root = styled.div`
    ${tw`mb-16`}
    display: flex;
    flex-direction: column;
    align-items: center;
    
    
    & p {
      ${tw`p-2 sm:p-6 md:p-0 mb-4`}
      max-width: 600px;
      font-size: 1rem;
    }

    & img {
      ${tw`mb-12`}
    }
  `;
